import { Alert, Input, Checkbox } from "@heroui/react";

interface EncryptionSetupFormProps {
  formValues: {
    password: string;
    confirmPassword: string;
    acknowledged: boolean;
    acknowledgedLimitedFunctionality: boolean;
  };
  errors: {
    password?: string;
    confirmPassword?: string;
    acknowledged?: string;
    acknowledgedLimitedFunctionality?: string;
  };
  isDisabled: boolean;
  onPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onAcknowledgedChange: (value: boolean) => void;
  onAcknowledgedLimitedFunctionalityChange: (value: boolean) => void;
}

export function EncryptionSetupForm({
  formValues,
  errors,
  isDisabled,
  onPasswordChange,
  onConfirmPasswordChange,
  onAcknowledgedChange,
  onAcknowledgedLimitedFunctionalityChange,
}: EncryptionSetupFormProps) {
  return (
    <div className="space-y-4">
      <Alert
        color="primary"
        title="Protect your data with encryption"
        description="Your notes will be encrypted with a master password that only you know. Store it safely."
      />
      <Input
        autoComplete="new-password"
        errorMessage={errors.password}
        isDisabled={isDisabled}
        isInvalid={!!errors.password}
        label="Master Password"
        name="password"
        placeholder="Enter a strong master password"
        size="sm"
        type="password"
        value={formValues.password}
        onValueChange={onPasswordChange}
      />

      <Input
        autoComplete="new-password"
        errorMessage={errors.confirmPassword}
        isDisabled={isDisabled}
        isInvalid={!!errors.confirmPassword}
        label="Confirm Password"
        name="confirmPassword"
        placeholder="Re-enter your master password"
        size="sm"
        type="password"
        value={formValues.confirmPassword}
        onValueChange={onConfirmPasswordChange}
      />

      <Checkbox
        isInvalid={!!errors.acknowledged}
        isDisabled={isDisabled}
        isSelected={formValues.acknowledged}
        onValueChange={onAcknowledgedChange}
      >
        <span className="text-default-600 text-sm">
          I understand that I cannot recover my data if I lose this password.
        </span>
      </Checkbox>

      <Checkbox
        isInvalid={!!errors.acknowledgedLimitedFunctionality}
        isDisabled={isDisabled}
        isSelected={formValues.acknowledgedLimitedFunctionality}
        onValueChange={onAcknowledgedLimitedFunctionalityChange}
      >
        <span className="text-default-600 text-sm">
          I acknowledge that some features may be limited with encryption enabled.
        </span>
      </Checkbox>
    </div>
  );
}
